// extracted by mini-css-extract-plugin
export var container = "_me-0";
export var dotAnimation = "_me-2";
export var dotsLoading = "_me-1";